import {useLogger} from "../../hooks/useLogger";
import axios from "axios";
import {BASE_URL, API_PAYMENTS, API_PAYMENTS_VERSION} from "./apiConstants";
import {keycloak} from "../keycloak";

const {logger} = useLogger();

let apiInstance = axios.create({
    baseURL: (process.env.API_PAYMENTS_BASE_URL || BASE_URL + API_PAYMENTS) + API_PAYMENTS_VERSION
});

apiInstance.interceptors.request.use(async (config) => {
    if (keycloak) {
        const token = keycloak.token || undefined;

        if (token) {
            keycloak.updateToken(process.env.KEYCLOAK_TOKEN_MIN_VALIDITY);
            config.headers.Authorization = `Bearer ${token}`;
        }
    }

    config.metadata = { startTime: new Date()};

    return config;
}, (err) => Promise.reject(err));

apiInstance.interceptors.response.use((response) => {
    return response;
}, function (error) {

    const xRequestID = error.request.getResponseHeader("x-request-id");

    error.config.metadata.endTime = new Date();
    error.duration = error.config.metadata.endTime - error.config.metadata.startTime;

    logger(error.message, "error", error.config?.baseURL?.slice(0, -1) + error.config?.url, error.stack, xRequestID, error.duration);

    return Promise.reject(error);
});

export const paymentsAPI = apiInstance;
